// 导入Vue核心库
import Vue from 'vue'
// 导入根组件App
import App from './App.vue'
// 导入路由配置
import router from './router'
// 导入Element UI组件库
import ElementUI from 'element-ui';
// 导入CSS重置样式表，用于统一不同浏览器的默认样式
import '@/assets/css/normalize.css'
// 导入Element UI的样式表
import 'element-ui/lib/theme-chalk/index.css';

// 设置为非生产环境下不显示提示信息
Vue.config.productionTip = false

// 全局注册Element UI组件库
Vue.use(ElementUI)

// 创建Vue实例
new Vue({
  // 注入路由配置
  router,
  // 渲染函数，将App组件渲染到页面上
  render: function (h) { return h(App) }
}).$mount('#app') // 将Vue实例挂载到id为app的DOM元素上
